/**
 * The supervisor's board (ASSIST-MNH): every facility of her woreda, zone or region, with the
 * figures each pack lists for supervision. Read from the server, so it needs a connection.
 */
import { useEffect, useState } from 'preact/hooks';
import { app } from '../controller.js';
import { t } from '../i18n.js';

interface Board {
  days: number;
  rows: Array<{
    facility: { id: string; name: string; woreda: string | null };
    values: Array<{
      pack: string;
      title: string;
      value: number | null;
      num: number;
      den: number | null;
    }>;
  }>;
}

export function Supervisor() {
  const [days, setDays] = useState(0);
  const [board, setBoard] = useState<Board | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    setBoard(null);
    setErr(null);
    void app
      .api<Board>(`/api/supervisor?days=${days}`)
      .then(setBoard)
      .catch((e: unknown) => setErr(e instanceof Error ? e.message : String(e)));
  }, [days]);
  const titles = [...new Set(board?.rows.flatMap((r) => r.values.map((v) => v.title)) ?? [])];
  return (
    <div class="card" data-card="supervisor">
      <div class="dhead">
        <div>
          <h3>{t.supervisorTitle}</h3>
          <p class="muted">{t.supervisorHelp}</p>
        </div>
        <label>
          {t.periodLabel}{' '}
          <select value={days} onChange={(e) => setDays(Number(e.currentTarget.value))}>
            {[0, 30, 90].map((d) => (
              <option key={d} value={d}>
                {t.periods[d]}
              </option>
            ))}
          </select>
        </label>
      </div>
      {err ? <p class="alert">{err}</p> : null}
      {!board && !err ? <p class="muted">{t.computing}</p> : null}
      {board ? (
        <div class="regwrap">
          <table class="reg">
            <thead>
              <tr>
                <th>{t.facilityCol}</th>
                {titles.map((x) => (
                  <th key={x}>{x}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {board.rows.map((r) => (
                <tr key={r.facility.id}>
                  <th>{r.facility.name}</th>
                  {titles.map((x) => {
                    const v = r.values.find((y) => y.title === x);
                    return (
                      <td key={x}>
                        {!v || v.value === null
                          ? '—'
                          : v.den !== null
                            ? `${v.value}% (${v.num}/${v.den})`
                            : v.value}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
